import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { styled, Theme } from '@mui/material/styles';
import Link from '@mui/material/Link';

const KYCPopup = styled(Stack)(({ theme }) => ({
    position: 'fixed',
    zIndex: '9999',
    background: ' rgba(0,0,0,.87)!important',
    transition: 'opacity 225mscubic-bezier(0.4, 0, 0.2, 1)',
    height: '100vh',
    top: '0px',
    width: '100%',
    left: '0px'
}));

const KycDeclinedPopUp = ({
    declinedText,
    kycLimitTimeAvailbale,
    disablePopUp
}: {
    declinedText: string | null | undefined;
    kycLimitTimeAvailbale: boolean;
    disablePopUp: Function;
}) => {
    const theme = useTheme();

    return (
        <>
            <KYCPopup>
                <Grid
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        maxWidth:'650px',
                        transform: 'translate(-50%, -50%)',
                        [theme.breakpoints.down(600)]: {
                            maxWidth:'initial',
                            width: '95%'
                        }
                    }}
                >
                    <Stack
                        sx={{
                            minHeight: '300px',
                            padding: '30px 40px 25px 40px',
                            background: '#26334d',
                            borderRadius: '10px',
                            [theme.breakpoints.down(600)]: {
                                padding: '15px'
                            }
                        }}
                    >
                        <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography
                                variant="h4"
                                sx={{ fontSize: '22px', pt: '20px', fontWeight: '900', color: theme.palette.secondary.main }}
                            >
                                KYC Verification unsuccessful!
                            </Typography>
                        </Grid>
                        <Grid container direction="row" justifyContent="center" alignItems="center">
                            <Grid sx={{ width: '100%' }} className="termsandcondition">
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontSize: '16px',
                                        pt: '20px',
                                        fontWeight: '900',
                                        color: '#fff',
                                        textAlign: 'center',
                                        [theme.breakpoints.down(600)]: {
                                            fontSize: '12px'
                                        }
                                    }}
                                >
                                    Remarks : {declinedText}
                                </Typography>
                                <Typography sx={{ fontSize: '13px', pt: '20px', fontWeight: '600', textAlign: 'center', color: '#A4ADC0' }}>
                                    Note: KYC verification takes 24 - 48 hours to complete.
                                </Typography>
                            </Grid>
                            <Grid
                                sx={{
                                    flexDirection: 'row',
                                    display: 'flex',

                                    gap: '30px',
                                    pt: '20px'
                                }}
                            >
                                {kycLimitTimeAvailbale ? (
                                    <Button
                                        onClick={() => disablePopUp()}
                                        sx={{
                                            backgroundColor: 'none',
                                            color: theme.palette.secondary.main,
                                            transition: 'all .2s ease-in-out',
                                            cursor: 'pointer',
                                            padding: '0px 20px',
                                            fontSize: '0.875rem',
                                            fontWeight: '600',
                                            fontFamily: '"Manrope", sans-serif',
                                            width: '100%',
                                            height: '40px',
                                            marginTop: '15px',
                                            border: '1px solid',
                                            borderColor: theme.palette.secondary.main,
                                            ':hover': {
                                                backgroundColor: 'none',
                                                color: theme.palette.secondary.main,
                                                transition: 'all .2s ease-in-out'
                                            }
                                        }}
                                    >
                                        Skip for now
                                    </Button>
                                ) : (
                                    ''
                                )}
                                {/* <Button
                                sx={{
                                    backgroundColor: 'none',
                                    color:theme.palette.secondary.main,
                                    transition: 'all .2s ease-in-out',
                                    cursor: 'pointer',
                                    padding: '0px 20px',
                                    fontSize: '0.875rem',
                                    fontWeight: '600',
                                    fontFamily: '"Manrope", sans-serif',
                                    width: '100%',
                                    height: '40px',
                                    marginTop: '15px',
                                    border:'1px solid',
                                    borderColor:theme.palette.secondary.main,
                                    ':hover': {
                                        backgroundColor: 'none',
                                        color:theme.palette.secondary.main,
                                        transition: 'all .2s ease-in-out'
                                    }
                                }}

                            >
                                Skip for now
                            </Button> */}
                                <Link
                                    sx={{
                                        backgroundColor: theme.palette.secondary.main,
                                        color: '#fff',
                                        transition: 'all .2s ease-in-out',
                                        cursor: 'pointer',
                                        padding: '0px 20px',
                                        fontSize: '0.875rem',
                                        fontWeight: '600',
                                        whiteSpace: 'nowrap',
                                        fontFamily: '"Manrope", sans-serif',
                                        width: '100%',
                                        height: '40px',
                                        marginTop: '15px',
                                        textDecoration: 'none',
                                        alignItems: 'center',
                                        display: 'flex',
                                        ':hover': {
                                            backgroundColor: theme.palette.secondary.main,
                                            color: '#fff',
                                            transition: 'all .2s ease-in-out'
                                        }
                                    }}
                                    href="/Kyc"
                                    target=""
                                >
                                    {' '}
                                    Complete KYC
                                </Link>
                            </Grid>
                        </Grid>
                    </Stack>
                </Grid>
            </KYCPopup>
        </>
    );
};

export default KycDeclinedPopUp;
